import { LegalLayout, H2, H3, P, Strong, UL, LI } from "@/components/legal/LegalLayout";

const TermsPage = () => (
  <LegalLayout
    title="Conditions Générales de Vente"
    subtitle="Version en vigueur au 26 août 2026"
  >
    <H2>Article 1 — Objet</H2>
    <P>Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les relations contractuelles entre :</P>
    <P>
      <Strong>SelfieBooth Event</Strong> — Walid Bourahla, auto-entrepreneur<br />
      SIRET : 931 457 360 00010<br />
      44B rue Gabriel Péri, 78210 Saint-Cyr-l&apos;École<br />
      Email : walid.societe.pro@gmail.com — Téléphone : 06 79 39 34 29
    </P>
    <P>Ci-après désigné « le Prestataire »,</P>
    <P>Et toute personne physique ou morale procédant à une réservation via le site selfieboothevent.fr, ci-après désignée « le Client ».</P>

    <H2>Article 2 — Prestations</H2>
    <P>Le Prestataire propose la location de photobooth (borne à selfies) pour tout événement privé ou professionnel : mariage, anniversaire, baptême, séminaire, soirée, etc.</P>
    <P>Les forfaits proposés incluent : livraison en Île-de-France, installation, technicien sur place, impressions illimitées et accessoires photobooth. Les détails précis figurent sur le devis émis pour chaque prestation.</P>

    <H2>Article 3 — Réservation et formation du contrat</H2>
    <P>La réservation s&apos;effectue en ligne sur le site selfieboothevent.fr. Le Client :</P>
    <UL>
      <LI>Choisit son forfait et sa date</LI>
      <LI>Renseigne ses coordonnées et le lieu de l&apos;événement</LI>
      <LI>Accepte le devis en cochant la case « J&apos;accepte le devis et confirme ma réservation »</LI>
    </UL>
    <P><Strong>L&apos;acceptation du devis par cette case à cocher constitue une signature électronique ayant la même valeur juridique qu&apos;une signature manuscrite</Strong> (article 1367 du Code civil). L&apos;horodatage et l&apos;adresse IP sont conservés à titre de preuve.</P>
    <P>Le contrat est formé dès validation de la case à cocher. Le Client reçoit alors un email de confirmation.</P>

    <H2>Article 4 — Prix et paiement</H2>
    <P>Les prix sont indiqués en euros TTC. En tant qu&apos;auto-entrepreneur soumis à la franchise en base de TVA (article 293 B du CGI), la TVA n&apos;est pas applicable.</P>
    <P><Strong>Modalités de paiement :</Strong></P>
    <UL>
      <LI>Aucun acompte n&apos;est demandé à la réservation</LI>
      <LI>Le règlement de la totalité du prix s&apos;effectue le jour de l&apos;événement</LI>
      <LI>Moyens acceptés : espèces, chèque à l&apos;ordre de Walid Bourahla, virement bancaire (RIB communiqué sur demande)</LI>
      <LI>Le règlement doit intervenir avant le début effectif de la prestation</LI>
    </UL>
    <P>En cas de retard de paiement, des pénalités de retard au taux légal en vigueur pourront être appliquées, majorées d&apos;une indemnité forfaitaire de 40€ pour frais de recouvrement (article D441-5 du Code de commerce).</P>

    <H2>Article 5 — Modification de la date</H2>
    <P>Le Client peut demander le report de la date de son événement dans les conditions suivantes :</P>
    <UL>
      <LI>La demande doit être formulée par écrit (email) au moins 15 jours avant la date initialement prévue</LI>
      <LI>Le report est gratuit dans un délai de 30 jours à compter de la date initiale, sous réserve de disponibilité du Prestataire</LI>
      <LI>Au-delà de 30 jours, le report est considéré comme une annulation suivie d&apos;une nouvelle réservation</LI>
    </UL>
    <P>Une seule demande de report est acceptée par réservation.</P>

    <H2>Article 6 — Annulation</H2>
    <H3>Par le Client</H3>
    <P>Le Client peut annuler sa réservation à tout moment, sans pénalité financière, en informant le Prestataire par email (walid.societe.pro@gmail.com) dès que possible.</P>
    <P>Toutefois, en cas d&apos;annulation tardive (moins de 48 heures avant l&apos;événement), le Client s&apos;engage à informer immédiatement le Prestataire par téléphone.</P>
    <H3>Par le Prestataire</H3>
    <P>En cas de force majeure ou d&apos;impossibilité technique (panne matérielle irréparable, accident, maladie), le Prestataire s&apos;engage à en informer immédiatement le Client et à proposer :</P>
    <UL>
      <LI>Soit un report à une date convenable</LI>
      <LI>Soit le remboursement intégral des sommes éventuellement déjà versées</LI>
    </UL>

    <H2>Article 7 — Droit de rétractation</H2>
    <P>Conformément à l&apos;article L221-28 12° du Code de la consommation, le droit de rétractation de 14 jours ne s&apos;applique pas aux prestations de services d&apos;hébergement, transport, restauration ou activités de loisirs devant être fournis à une date déterminée.</P>
    <P>La réservation d&apos;un photobooth pour une date fixée entre dans cette catégorie et n&apos;ouvre donc pas droit à rétractation.</P>

    <H2>Article 8 — Obligations du Client</H2>
    <P>Le Client s&apos;engage à :</P>
    <UL>
      <LI>Fournir des informations exactes lors de la réservation</LI>
      <LI>Prévoir un accès au lieu de l&apos;événement pour le Prestataire (véhicule utilitaire)</LI>
      <LI>Mettre à disposition une prise électrique standard 220V à proximité de l&apos;emplacement prévu</LI>
      <LI>Prévoir un emplacement d&apos;environ 3m² sécurisé et à l&apos;abri des intempéries</LI>
      <LI>Régler la prestation dans les conditions prévues à l&apos;article 4</LI>
      <LI>Ne pas dégrader le matériel du Prestataire</LI>
    </UL>
    <P>En cas de dégradation matérielle du fait du Client ou de ses invités, une facture de remise en état ou de remplacement sera adressée au Client.</P>

    <H2>Article 9 — Obligations du Prestataire</H2>
    <P>Le Prestataire s&apos;engage à :</P>
    <UL>
      <LI>Se présenter à l&apos;heure convenue avec le matériel en bon état de fonctionnement</LI>
      <LI>Assurer le bon fonctionnement du photobooth durant toute la durée prévue</LI>
      <LI>Rester présent (ou joignable en cas d&apos;installation autonome) durant la prestation</LI>
      <LI>Restituer aux invités les tirages photo prévus au forfait</LI>
      <LI>Retirer son matériel à la fin de la prestation</LI>
    </UL>

    <H2>Article 10 — Droit à l&apos;image</H2>
    <P>Les photographies prises par le photobooth appartiennent au Client et à ses invités. Le Prestataire s&apos;engage à ne les utiliser à des fins de communication (site web, réseaux sociaux, portfolio) qu&apos;avec l&apos;autorisation écrite préalable du Client et des personnes reconnaissables.</P>

    <H2>Article 11 — Responsabilité</H2>
    <P>La responsabilité du Prestataire est limitée au montant total de la prestation facturée. En aucun cas le Prestataire ne pourra être tenu responsable de dommages indirects (perte de chance, préjudice moral, etc.).</P>
    <P>Le Prestataire est couvert par une assurance responsabilité civile professionnelle.</P>

    <H2>Article 12 — Données personnelles</H2>
    <P>Le traitement des données personnelles du Client est régi par la Politique de Confidentialité disponible sur le site à l&apos;adresse : <a href="/politique-confidentialite" style={{ color: "#B8977E" }}>selfieboothevent.fr/politique-confidentialite</a></P>

    <H2>Article 13 — Médiation de la consommation</H2>
    <P>Conformément aux articles L611-1 et suivants du Code de la consommation, en cas de litige, le Client consommateur peut recourir gratuitement au service de médiation.</P>
    <P style={{ fontSize: "0.85rem", color: "#8a7a70", fontStyle: "italic" }}>Coordonnées du médiateur à compléter après adhésion à un dispositif de médiation agréé.</P>
    <P>Le recours au médiateur est facultatif et sans préjudice d&apos;une action judiciaire.</P>

    <H2>Article 14 — Droit applicable et juridiction</H2>
    <P>Les présentes CGV sont soumises au droit français. En cas de litige non résolu à l&apos;amiable, les tribunaux français seront seuls compétents.</P>

    <H2>Article 15 — Acceptation des CGV</H2>
    <P>L&apos;acceptation du devis via la case à cocher lors de la réservation vaut acceptation pleine et entière des présentes CGV, que le Client déclare avoir lues et comprises.</P>
  </LegalLayout>
);

export default TermsPage;
